export enum ExpensesState {
  Pending,
  Approved,
  Rejected,
}
